var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "score"
  }, [_c('div', {
    staticClass: "star-box"
  }, [_c('div', {
    staticClass: "star"
  }, [_c('div', {
    class: 'star_orange' + _vm.star1_width
  }), _c('div', {
    staticClass: "star_xingxing"
  })]), _c('div', {
    staticClass: "star"
  }, [_c('div', {
    class: 'star_orange' + _vm.star2_width
  }), _c('div', {
    staticClass: "star_xingxing"
  })]), _c('div', {
    staticClass: "star"
  }, [_c('div', {
    class: 'star_orange' + _vm.star3_width
  }), _c('div', {
    staticClass: "star_xingxing"
  })]), _c('div', {
    staticClass: "star"
  }, [_c('div', {
    class: 'star_orange' + _vm.star4_width
  }), _c('div', {
    staticClass: "star_xingxing"
  })]), _c('div', {
    staticClass: "star"
  }, [_c('div', {
    class: 'star_orange' + _vm.star5_width
  }), _c('div', {
    staticClass: "star_xingxing"
  })])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };